export class Authentication {
    static username = 'xsssxx';
    static password = 'dsssdd';
}

